import { UiState } from 'instantsearch.js';

export const parseURL = (index: string) => {
  return ({ qsModule, location }: { qsModule: any; location: Location }) => {
    const params = location.search.slice(1);
    const parsed = qsModule.parse(params);

    const { pris, q, sortering, side, lager, ...refinementList } = parsed;

    const transformedRefinementList: any = {};

    // Translate
    Object.keys(refinementList || {}).forEach((key) => {
      const value = refinementList[key];

      switch (key) {
        case 'category':
          if (typeof value === 'string') {
            transformedRefinementList['articleGroups.lvl1'] = value.split(',');
          } else {
            transformedRefinementList['articleGroups.lvl1'] = [...value];
          }
          break;
        case 'farge':
          if (typeof value === 'string') {
            transformedRefinementList.colour = [value];
          } else {
            transformedRefinementList.colour = [...value];
          }
          break;
        default:
          if (Array.isArray(value)) {
            transformedRefinementList[key] = [...value];
          } else {
            transformedRefinementList[key] = [value];
          }
          break;
      }
    });

    if (lager) {
      transformedRefinementList.storesWithStockOrDisplay = [lager];
    }

    const newState: any = {};

    // Translate price
    if (pris) {
      newState.range = {
        price: decodeURIComponent(`${pris}`),
      };
    }

    // Translate sort
    if (sortering) {
      newState.sortBy = decodeURIComponent(`${sortering}`);
    }

    if (q) {
      newState.query = decodeURIComponent(`${q}`);
    }

    if (
      transformedRefinementList &&
      Object.keys(transformedRefinementList).length > 0
    ) {
      newState.refinementList = transformedRefinementList;
    }

    if (side) {
      newState.page = parseInt(`${side}`);
    }

    const newUiState: UiState = {
      [index]: {
        ...newState,
      },
    };

    return newUiState;
  };
};
